$('.payment-and-quantity .qty-adjuster__down').click(function(e){
  e.preventDefault();
  var moq = $(this).attr('data-min');
  var current_quantity = $('.payment-and-quantity .qty-adjuster__value').val();
  setTimeout(function(){
    var qty = parseInt(current_quantity) - parseInt(1);
    if(qty > moq){
      $('.payment-and-quantity .qty-adjuster__value').val(qty).trigger('change');
      $('.payment-and-quantity .qty-adjuster__down').attr('disabled', false);
      $('.moq_error').hide();
    }else{
      $('.payment-and-quantity .qty-adjuster__value').val(moq);
      $('.payment-and-quantity .qty-adjuster__down').attr('disabled', false);
      $('.moq_error').show();
    }
  },200);
});
$('.payment-and-quantity .qty-adjuster__up').click(function(e){
  e.preventDefault();
  var moq = $(this).attr('data-min');
  var current_quantity = $('.payment-and-quantity .qty-adjuster__value').val();
  setTimeout(function(){
    var qty = parseInt(current_quantity) + parseInt(1);
    if(qty > moq){
      $('.payment-and-quantity .qty-adjuster__value').val(qty).trigger('change');
      $('.payment-and-quantity .qty-adjuster__down').attr('disabled', false);
      $('.moq_error').hide();
    }else{
      $('.payment-and-quantity .qty-adjuster__value').val(current_quantity);
      $('.moq_error').show();
    }	
  },200);
});

$('.payment-and-quantity .qty-adjuster__value').on('change paste keyup',function(){
  var qty = parseInt($(this).val());
  var moq = parseInt($(this).attr('data-min'));
  if(qty > moq){
    //$('.product-form__add-button').prop('disabled',false);
    //$('.moq_error').hide();
  }else{
    $(this).val(moq);
    
    //$('.product-form__add-button').prop('disabled',true);
    //$('.moq_error').show();
  }
});
